import stores from "@/storage/stores";
import { isAppleDevice } from "../fetch/isAppleDevice";
import { jwt } from "@/event/jwt/jwt";

export function getTokenByDevice(): object {
    let data: object = {}

    const store = stores.getStoresData();
    const storeId = store.store_id;
    const storeName = store.name;
    const token = jwt.value;

    if (!storeId) return data;

    let refreshToken: string | null = null;
    if (isAppleDevice()) {
        refreshToken = storeName
            ? localStorage.getItem(`${storeName}_refresh_token`)
            : localStorage.getItem('refresh_token');

        if (!refreshToken) return data

        data = {
            access_token: token,
            refresh_token: refreshToken,
            store_id: storeId
        }
    } else {
        data = {
            access_token: '',
            refresh_token: '',
            store_id: storeId
        }
    }

    return data;
}